import Sidebarmenu from '../components/Sidebarmenu/Sidebarmenu';
import Table from '../components/Table/Table';
import Usermenu from '../components/Usermenu/Usermenu';
import Coursetable from '../components/Coursetable/Coursetable';
import Sidebar from '../components/Sidebar/Sidebar';
import Copilot from '../components/Copilot/Copilot';
import Authoringcoursespagination from '../components/Authoringcoursespagination/Authoringcoursespagination';
import Footer from '../components/Footer/Footer';
import Authoringcoursesrow from '../components/Authoringcoursesrow/Authoringcoursesrow';
import Header from '../components/Header/Header'; /* eslint-disable */

import React from 'react';
import { createScope, map, transformProxies } from './helpers';

const scripts = [
  {
    loading: Promise.resolve(
      '$(".show-tenants").click(function(t){t.preventDefault(),$(".user-tenants").toggle()});var currentPath=window.location.pathname;"/"===currentPath&&$(\'.menu-wr[data-name="overview"]\').addClass("active");'
    ),
    isAsync: false,
  },
  {
    loading: Promise.resolve(
      '($=jQuery)(document).ready(function(){$(".left_mobile_nav_trigger").on("click",function(){$(".left_menu_mob").toggle()}),$(".link-options").click(function(){var t=$(this).attr("data-name");$(".link-options").each(function(t){$(this).removeClass("active")}),$(this).addClass("active"),$(".panel").each(function(t){$(this).removeClass("active")}),$(".panel[data-name="+t+"]").addClass("active")}),$(".layout-div").click(function(){$(".layout-div").each(function(){$(this).removeClass("active")}),$(this).addClass("active")}),$(".create-dashboard").click(function(){$(".create-report-popup").addClass("show")}),$(".cancel-create-report").click(function(){$(".create-report-popup").removeClass("show")}),$(".create-report").click(function(){$(".create-report-popup").removeClass("show")}),$(".prof_menu").click(function(){$(".prof_menu").each(function(t){$(this).removeClass("active")});var t=$(this).attr("data-name");console.log(t),$(".ov_panel").each(function(t){$(this).removeClass("active")}),$(".ov_panel[data-name="+t+"]").addClass("active"),$(this).addClass("active")}),$(".roles").click(function(){$(".roles_popup").toggle()}),$(".roles").click(function(t){t.stopPropagation()}),$(".send-message").click(function(){$(".popup_div").addClass("show"),$("body").addClass("locked")}),$(".cancel_btn").click(function(){$(".popup_div").removeClass("show"),$("body").removeClass("locked")}),$(".web-sub").not(".active").each(function(t){$(this).click(function(){$(this).children(".w_menu").toggleClass("active"),$(this).parent().addClass("active")})}),$(".downloads_trigger").click(function(){$(".download_popup").toggle()}),$(window).click(function(){$(".download_popup")[0]&&($(".download_popup")[0].style.display="none")}),$(".downloads_trigger").click(function(t){t.stopPropagation()}),$(".tp_trigger").each(function(t){$(this).on("mouseover",function(){$(".tp_content")[t].style.visibility="visible"}),$(this).on("mouseout",function(){$(".tp_content")[t].style.visibility="hidden"})}),$(".menu-wr").not(".active").each(function(t){$(this).click(function(){0<$(this).children(".submenu").length&&($(this).children(".submenu").hasClass("clicked")?$(this).children(".submenu").removeClass("clicked"):$(this).children(".submenu").addClass("clicked"),$(".submenu").not($(this).children(".submenu")).each(function(t){$(this).removeClass("clicked")}))})}),$(".mob_nav_trigger").click(function(){$(".sidebar")[0].style.display="block",$(".sidebar")[0].style.left="0px",$(".mob_sidebar_overlay")[0].style.display="block",$(".body")[0].style.overflow="hidden"}),$(".mob_sidebar_overlay").click(function(){$(".sidebar")[0].style.left="-230px",$(".mob_sidebar_overlay")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".mobile_menu").click(function(t){t.stopPropagation()}),$(".mobile_nav_trigger").click(function(t){t.stopPropagation()}),$(".profile_menu_trigger").click(function(){$(".prof_menu_popup").toggle()}),$(window).click(function(){$(".prof_menu_popup").each(function(t){$(this)[0].style.display="none"}),$(".roles_popup")[0].style.display="none"}),$(".profile_menu_trigger").click(function(t){t.stopPropagation()}),$(".options_trigger").each(function(t){$(this).click(function(){$(".actions").each(function(t){$(this)[0].style.display="none"}),$(".actions")[t].style.display="block"})}),$(window).click(function(){$(".actions").each(function(t){$(this)[0].style.display="none"})}),$(".options_trigger").click(function(t){t.stopPropagation()}),$(".unit-name").each(function(t){$(this).click(function(){$(this).parent().hasClass("active")?($(".unit_row")[t].classList.remove("active"),$(".minus")[t].classList.remove("active"),$(".plus")[t].classList.add("active"),$(".unit_description")[t].classList.remove("active")):($(".unit_row")[t].classList.add("active"),$(".minus")[t].classList.add("active"),$(".plus")[t].classList.remove("active"),$(".unit_description")[t].classList.add("active"))})}),$(".menu-wr.web").each(function(t){$(this).click(function(t){console.log(t.target),(t.target.classList.contains("menu-option")||t.target.classList.contains("text-block-107")||t.target.classList.contains("fa_icon")||t.target.classList.contains("menu-icon")||t.target.classList.contains("link-block-13"))&&$(this).children(".submenu").toggleClass("active")})})}),$(".export_to_csv").each(function(t){$(this).click(function(){window.open("https://docs.google.com/spreadsheets/d/e/2PACX-1vRk0PYQrq-pES_V3Gn6qgQUj6KKe5YrpKSyoJJu7cgIWRmtZjMsaxlfIMtU7RLrppLxHMVokZYenq0X/pub?output=csv","_blank")})}),$(".more-btn").click(function(){var t=$(this).attr("data-name");$(\'.more-h[data-name="\'+t+\'"]\').show(),$(this).hide()}),$(".select-field-6").on("change",function(){var t=this.value,e=$(this).closest(".div-block-202");let i=parseInt($(e).find(".text-block-110.n").attr("data-default")),n=parseInt($(e).find(".text-block-110.n").attr("data-dn")),a=("b"==$(this).attr("data-type")&&(i=345,n=345),""),c="";"lw"==t?(c=i,a=n):"lm"==t?(c=i+20,a=n+20,newPerc=Math.round((c-i)/i*100),$(e).find(".text-block-110.per").html("+"+a+" (+"+newPerc+"%)"),$(e).find(".text-block-110.per").addClass("up"),$(e).find(".image-6.caret").addClass("up").attr("src","https://assets.website-files.com/63628e2a6d1095f29b34a624/6369358bff42b16cfcc0a0cd_636934d9d5bff525e7d57ae1_arrow-up.png")):"at"==t?(c=i+25,a=n+25,newPerc=Math.round((c-i)/i*100),$(e).find(".text-block-110.per").html("+"+a+" (+"+newPerc+"%)"),$(e).find(".text-block-110.per").addClass("up"),$(e).find(".image-6.caret").addClass("up").attr("src","https://assets.website-files.com/63628e2a6d1095f29b34a624/6369358bff42b16cfcc0a0cd_636934d9d5bff525e7d57ae1_arrow-up.png")):"c"==t||"nm"==t?(c=i,a=n):"ny"==t?(c=i+85,a=n+85,newPerc=Math.round((c-i)/i*100),$(e).find(".text-block-110.per").html("+"+a+" (+"+newPerc+"%)"),$(e).find(".text-block-110.per").addClass("up"),$(e).find(".image-6.caret").addClass("up").attr("src","https://assets.website-files.com/63628e2a6d1095f29b34a624/6369358bff42b16cfcc0a0cd_636934d9d5bff525e7d57ae1_arrow-up.png")):"n3y"==t&&(c=i+240,a=n+240,newPerc=Math.round((c-i)/i*100),$(e).find(".text-block-110.per").html("+"+a+" (+"+newPerc+"%)"),$(e).find(".text-block-110.per").addClass("up"),$(e).find(".image-6.caret").addClass("up").attr("src","https://assets.website-files.com/63628e2a6d1095f29b34a624/6369358bff42b16cfcc0a0cd_636934d9d5bff525e7d57ae1_arrow-up.png")),$(e).find(".text-block-110.n").html(c),$(e).find("span.dn").html(a)}),$(".text-block-107").each(function(t){"BEHAVIOR"==$(this).html()&&$(this).html("ENGAGEMENT")}),$(".select-field-7").on("change",function(){let e=$(this).val();var t,i;"c"!=e&&(i=$(this).closest(".div-block-202"),t=$(i).find(".text-block-110.sml"),i=$(i).find(".div-block-209"),$(t).each(function(t){$(this).hide()}),$(t).each(function(t){$(this).attr("data-name")==e&&$(this).show()}),$(i).each(function(t){$(this).hide()}),$(i).each(function(t){$(this).attr("data-name")==e&&($(this)[0].style.display="flex")}))}),$(".select-field-8").on("change",function(){let e=$(this).val();var t,i;"c"!=e&&(i=$(this).closest(".div-block-202"),t=$(i).find(".text-block-110.n"),i=$(i).find(".div-block-209"),$(t).each(function(t){$(this).hide()}),$(t).each(function(t){$(this).attr("data-name")==e&&$(this).show()}),$(i).each(function(t){$(this).hide()}),$(i).each(function(t){$(this).attr("data-name")==e&&($(this)[0].style.display="flex")}))}),$(".select-field-9").on("change",function(){var e=$(this).val();if("c"!=e){$(this).attr("data-type");var i=$(this).closest(".gr_div"),n=($(i).find("#sperc").html(),$(this).attr("data-def"));let t="";"lw"==e?t=+n:"lm"==e?t=+n+3:"at"==e&&(t=+n+6);e=t+"%";$(i).find("#sperc").html(e),$(i).find("#ib")[0].style.backgroundImage="conic-gradient(from 155deg, #527bcd "+t+"%, #525252 0); !important",console.log($(i).find("#ib"))}});'
    ),
    isAsync: false,
  },
  {
    loading: Promise.resolve(
      '!function(t){t(window).on("load",function(){t(".table_cont").mCustomScrollbar({axis:"x",theme:"light-3"}),t(".table_cont-2").mCustomScrollbar({axis:"x",theme:"light-3"}),t(".custom_slider").mCustomScrollbar({axis:"x",theme:"light-3"})})}(jQuery);'
    ),
    isAsync: false,
  },
  {
    loading: Promise.resolve(
      'jQuery(function(o){o(".copilot-input-box form").on("submit",function(t){t.preventDefault();const n=o(this).closest(".copilot-input-box");return n.addClass("is-generating"),n.find(".copilot-input-box-content:not(.copilot-input-box-content-generating)").hide(),n.find(".copilot-input-box-content.copilot-input-box-content-generating").css({display:"flex"}),setTimeout(()=>{n.removeClass("is-generating"),n.find(".copilot-input-box-content:not(.copilot-input-box-content-generating)").css({display:"flex"}),n.find(".copilot-input-box-content.copilot-input-box-content-generating").hide()},6e3),!1}),o(".copilot-input-box-action-btn.submit-button").on("click",function(t){t.preventDefault(),o(".copilot-input-box form").trigger("submit")}),o(".copilot-file-upload-btn").on("click",function(t){t.preventDefault(),o(".input-file-upload").trigger("click")})});'
    ),
    isAsync: false,
  },
  {
    loading: Promise.resolve(
      'var padLeft,padRight,padTotal,originalWidth,initialWebPageWidth,copilotWidth,wholeDocSize=$(window).width();const isMobile=window.innerWidth<=768;jQuery(function(t){t(".copilot-container").resizable({handles:{w:".resize-seperator-block"},minWidth:380,start:function(i,o){padLeft=o.element.css("padding-left").replace("px",""),padRight=o.element.css("padding-right").replace("px",""),padTotal=parseFloat(padLeft+padRight),originalWidth=o.size.width,o.size.width=o.size.width+padTotal},resize:function(i,o){t(".webpage-container").css({width:wholeDocSize-o.size.width+"px"})}}),t(".copilot-closer-btn").on("click",function(){initialWebPageWidth=t(".webpage-container").width(),copilotWidth=t(".copilot-container").width(),isMobile?(t(".floating-copilot-launcher").show(),t(".copilot-container").hide()):(t(".floating-copilot-launcher").toggleClass("hidden"),t(".copilot-container").toggleClass("hidden")),t(".webpage-container").css({width:"100%"})}),t(".floating-copilot-launcher").on("click",function(){t(".webpage-container").css({width:initialWebPageWidth+"px"}),t(".copilot-container").css({width:copilotWidth+"px"}),t(".copilot-container").hasClass("hidden")?t(".copilot-container").toggleClass("hidden"):(t(".copilot-container").css({display:"inline-block"}),isMobile&&t(".copilot-container").css({position:"fixed"})),isMobile?t(".floating-copilot-launcher").hide():t(".floating-copilot-launcher").toggleClass("hidden")})});'
    ),
    isAsync: false,
  },
];

let Controller;

class CoursesView extends React.Component {
  static get Controller() {
    if (Controller) return Controller;

    try {
      Controller = require('../controllers/CoursesController');
      Controller = Controller.default || Controller;

      return Controller;
    } catch (e) {
      if (e.code == 'MODULE_NOT_FOUND') {
        Controller = CoursesView;

        return Controller;
      }

      throw e;
    }
  }

  componentDidMount() {
    const htmlEl = document.querySelector('html');
    htmlEl.dataset['wfPage'] = '65830fc855f7d3a66ce3da0b';
    htmlEl.dataset['wfSite'] = '657af3ad1367da03b3b12527';

    scripts.concat(null).reduce((active, next) =>
      Promise.resolve(active).then((active) => {
        const loading = active.loading.then((script) => {
          new Function().call(window, script);
          return next;
        });

        return active.isAsync ? next : loading;
      })
    );
  }

  render() {
    const proxies =
      CoursesView.Controller !== CoursesView
        ? transformProxies(this.props.children)
        : {};

    return (
      <span>
        <style
          dangerouslySetInnerHTML={{
            __html: `
          @import url(/css/normalize.css);
          @import url(/css/webflow.css);
          @import url(/css/ibl-ai-analytics-pro-v2.webflow.css);
          @import url(https://drive.google.com/uc?export=view&id=1DZ1X4oaKbcEoicQQ7AMublzIQKQhL2ZZ);


            .merlin.chat{
            	display:none;
            }



            .circle .inner{
                background: #272c34 !important;
              color: #fff !important;
            }
            label.switch {
              margin-bottom: 0;
          }
          .switch {
              position: relative;
              display: inline-block;
              width: 33px;
              height: 15px;
          }
            .switch input {
              opacity: 0;
              width: 0;
              height: 0;
          }
            .switch input:checked + .slider {
              background-color: rgba(82, 123, 205, 0.6);
          }
          .switch .slider.round {
              border-radius: 34px;
          }
          .switch .slider {
              position: absolute;
              cursor: pointer;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-color: #525252;
              -webkit-transition: .4s;
              transition: .4s;
          }
            .switch input:checked + .slider:before {
              background-color: rgba(82, 123, 205, 1);
          }
          .switch input:checked + .slider:before {
              -webkit-transform: translateX(16px);
              -ms-transform: translateX(16px);
              transform: translateX(16px);
          }
          .switch .slider.round:before {
              border-radius: 50%;
          }
          .switch .slider:before {
              position: absolute;
              content: \"\";
              height: 17px;
              width: 17px;
              left: 0px;
              bottom: -1px;
              background-color: white;
              -webkit-transition: .4s;
              transition: .4s;
          }
            .create-report-popup select {
            	-webkit-appearance: listbox !important
            } 
            .profile_menu .mCSB_container{
            min-width: 900px;
          }
            .profile_menu .mCustomScrollBox{
            	width:97%;
            }
          @media screen and (min-width: 1280px) {
            .sk1 .mCSB_container{
              width: auto !important;
              left:0 !important;
             }
          }
          input, textarea {
            color: #fff !important;
          }
          	body.locked{
            overflow: hidden !important;
          }
            .tp_content{
            	visibility:hidden;
            }
            .submenu.clicked{
            	display:block;
              padding: 0px;
              background-color: #383d48;
            }
            @media screen and (min-width: 991px) {
            .sidebar{
              left:0 !important;
            }
          }
            .sidebar{
            transition: 0.5s;
            }
            iframe{
            border:none !important;
            }
            .l1.tr{
            	flex-shrink:0;
            }
            .nav{
            border-image: linear-gradient( 90deg ,#0A3B63, #527bcd) 3;
          }
            #myChart2{
            	height:220px !important;
            }
           .menu-option.active {
            border-image: linear-gradient( 180deg ,#851168,#f75eef) 2;
            }
              .submenu-item.active:hover:not(.web) {
            border-image: linear-gradient( 180deg ,#fff,#fff) 2;
            }
                .submenu-item.active:not(.web):not(.web-sub) {
            border-image: linear-gradient( 180deg ,#fff,#fff) 2;
            }
             .submenu-item:hover:not(.active) {
            border-image: linear-gradient( 180deg ,#fff,#fff) 2;
            }
                .submenu-item:hover:not(.active) > a {
            color: #fff !important;
          }
            .link-block-13:hover:not(.active){
            border-image: linear-gradient( 180deg ,#851168,#f75eef) 2;
          }
          .link-block-13:hover:not(.active){
            color: #527bcd !important;
          }
          .link-block-13:hover:not(.active)  .text-block-107{
            color: #527bcd !important;
          }
            .link-block-13:hover:not(.active) .icon{
              display: none !important;
          }
          .link-block-13:hover:not(.active) .icon_h{
              display: inline !important;
          }
            .image-4{
              box-shadow:0 0 1px 1px #fff;
            }
            .submenu-item.active:not(.web):not(.web-sub){
              border-image: linear-gradient( 180deg ,#851168,#f75eef) 2 !important;
          }
          .link-block-12.active{
            color: #527bcd !important;
          }
          .submenu-item.web-sub:hover{
              border-color: transparent !important;
              border-image: none !important;
          }
            ::-webkit-scrollbar {
            width: 6px;
            height: 6px;
          }
          ::-webkit-scrollbar-track {
            border-radius: 10px;
            background:  rgba(255, 255, 255, 0.2);
          }
          ::-webkit-scrollbar-thumb{
            border-radius: 10px;
          }
          ::-webkit-scrollbar-thumb:hover{
            background: rgba(255, 255, 255, 0.4);
          }
          ::-webkit-scrollbar-thumb:active{
            background: rgba(255, 255, 255, 0.5);
          }
            .submenu-item:hover:not(.active) > a {
            color: #527bcd !important;
          }
            .submenu-item:hover:not(.active):not(.web-sub) {
              border-image: linear-gradient( 180deg ,#851168,#f75eef) 2 !important;
          }
          .tp_content.sho{
          visibility: visible;
            display:none;
          }
            .tp_content{
            	display:none;
            }
          @media screen and (max-width: 991px) {
            .real_map{
              height: 350px !important;
            }
          }
            .mob_nav {
              border-image: linear-gradient( 90deg ,#0A3B63, #527bcd) 3 !important;
          }
            .mob_nav .text-block-125{
            	display:none;
            }
            ::-webkit-scrollbar-track {
            border-radius: 10px;
            background:  rgba(255, 255, 255, 0.2) !important;
          }
          ::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background:  rgba(255, 255, 255, 0.4) !important;
          }
          ::-webkit-scrollbar-thumb:hover{
            background:  rgba(255, 255, 255, 0.6) !important;
          }
          ::-webkit-scrollbar-thumb:active{
            background:  rgba(255, 255, 255, 0.8) !important;
          }
              .table_cont-2::-webkit-scrollbar-track {
          border-radius: 10px;
          background: transparent !important;
          }
          .table_cont-2::-webkit-scrollbar-thumb{
          border-radius: 10px;
          background:  #527bcd !important;
          }
          .table_cont-2::-webkit-scrollbar-thumb:hover{
          background:  #527bcd !important;
          }
          .table_cont-2::-webkit-scrollbar-thumb:active{
          background:  #527bcd !important;
          }
                .div-block-183.w_i::-webkit-scrollbar-track {
          border-radius: 10px;
          background: transparent !important;
          }
          .div-block-183.w_i::-webkit-scrollbar-thumb{
          border-radius: 10px;
          background:  #527bcd !important;
          }
          .div-block-183.w_i::-webkit-scrollbar-thumb:hover{
          background:  #527bcd !important;
          }
          .div-block-183.w_i::-webkit-scrollbar-thumb:active{
          background:  #527bcd !important;
          }
                  .div-block-183.wr.sp::-webkit-scrollbar-track {
          border-radius: 10px;
          background: transparent !important;
          }
          .div-block-183.wr.sp::-webkit-scrollbar-thumb{
          border-radius: 10px;
          background:  #527bcd !important;
          }
          .div-block-183.wr.sp::-webkit-scrollbar-thumb:hover{
          background:  #527bcd !important;
          }
          .div-block-183.wr.sp::-webkit-scrollbar-thumb:active{
          background:  #527bcd !important;
          }
            @media screen and (max-width: 410px) {
          	.apexcharts-legend {
          		bottom: -15% !important;
          	}
          }
            select {
            	-webkit-appearance: none;
            }
            .form-block-2 form{
            display:flex
          }
          .form-block-2 form:after {
             color: #9da5b4;
             content: \'\';
                font-family: \'Fa solid 900\', sans-serif;
            font-size:11px;
            position:relative;
            margin-left:-12px;
            z-index:1;
          }
            .select-field-6{
            	z-index:2;
            }
           .mCSB_horizontal.mCSB_inside > .mCSB_container{
            margin-bottom: 0 !important;
          }
          @media only screen and (min-width: 650px) {
            .mCSB_scrollTools_horizontal{
              display: none !important;
            }
          }
          .profile_menu .mCSB_scrollTools_horizontal{
              display: block !important;
            }
            @media only screen and (max-width: 650px) {
              	.mCSB_horizontal.mCSB_inside > .mCSB_container{
            margin-bottom: 12px !important;
          }
          .profile_menu .mCSB_horizontal.mCSB_inside > .mCSB_container {
              margin-bottom: 12px !important;
          }
          }
            @media screen and (max-width: 620px) {
            .real_map{
              height: 49vw !important;
            }
          }
          @media screen and (max-width: 450px) {
            .real_map{
              height: 47vw !important;
            }
          }
            .grid-2 .table_cont-2{
            	margin-bottom:0 !important;
            }
            .tp_trigger:hover .tp_content{
            display: block;
            visibility: visible
          }
            body{
            	min-width:0 !important;
            	}
            .main-content{
            	    min-height: calc(100vh - (65.5px + 88px));
            }
            @media screen and (max-width: 1330px) {
            .div-block-285._4-items{
              grid-template-columns: 1fr 1fr;
            }
          }
              @media screen and (max-width: 767px) {
            .div-block-285._4-items{
              grid-template-columns: 1fr;
            }
          }
            @media only screen and (min-width: 1625px) {
          .profile_menu .mCSB_scrollTools_horizontal{
                display: none !important;
              }
            }
          .profile_menu .mCSB_horizontal.mCSB_inside > .mCSB_container {
              margin-bottom: 12px !important;
          }



          @supports (-webkit-overflow-scrolling: touch) {
             .copilot-container textarea:focus {
               font-size: 16px;
             }
          }
          @media screen and (max-width:769px){
          	.resize-seperator-block{
            	display:none!important;
            }
          }
          .resize-seperator-block{
              		cursor: ew-resize!important;
                  display:flex;
                  left: -13px!important;
                  width: 20px!important;
              }
              .ui-resizable{
                  left: unset!important;
                  height:100%!important;
              }
          .copilot-input-box, .gradient-border{
            border-image-slice: 1;
            border-image-source: linear-gradient(198deg, rgba(36,103,235,1) 12%, rgba(36,103,235,0.30858280812324934) 90%);
          }
          .copilot-input-box.is-generating, .gradient-border.is-generating{
          --angle: 198deg;
          border-image-slice: 1;
            border-image-source: linear-gradient(var(--angle), rgba(36,103,235,1) 12%, rgba(36,103,235,0.30858280812324934) 90%);
            animation: .8s rotate linear infinite;
          }
          @keyframes rotate {
            to {
              --angle: 120deg;
            }
          }
          @property --angle {
            syntax: \'<angle>\';
            initial-value: 0deg;
            inherits: false;
          }
        `,
          }}
        />
        <span className="af-view">
          <div className="body">
            <div className="w-layout-hflex fullpage-container">
              <div className="w-layout-vflex webpage-container">
                <Header></Header>
                <div className="mob_nav">
                  <div className="div-block">
                    <div className="mob_nav_trigger">
                      <div className="text-block-134 fa_icon"></div>
                    </div>
                    <a
                      className="link-block-17 w-inline-block"
                      href="index.html"
                    >
                      <img
                        alt=""
                        className="image mob-logo"
                        loading="lazy"
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 34vw, (max-width: 991px) 202.1640625px, 100vw"
                        src="images/ibl-logos--copy_1.png"
                        srcset="images/ibl-logos--copy_1-p-500.png 500w, images/ibl-logos--copy_1-p-800.png 800w, images/ibl-logos--copy_1-p-1080.png 1080w, images/ibl-logos--copy_1-p-1600.png 1600w, images/ibl-logos--copy_1-p-2000.png 2000w, images/ibl-logos--copy_1.png 2245w"
                      />
                    </a>
                    <div className="s-input">
                      <div className="form-block-4 w-form">
                        <form
                          className="form"
                          data-name="Email Form 4"
                          data-wf-element-id="568bac3c-da8e-db57-58f5-e56bfc43dece"
                          data-wf-page-id="65830fc855f7d3a66ce3da0b"
                          id="email-form-4"
                          method="get"
                          name="email-form-4"
                        >
                          <div className="div-block-245">
                            <input
                              className="text-field-2 w-input"
                              data-name="Name 2"
                              id="name-2"
                              maxLength={256}
                              name="name-2"
                              placeholder=""
                              type="text"
                            />
                            <div className="div-block-246">
                              <div className="text-block fa_icon mg"></div>
                            </div>
                          </div>
                        </form>
                        <div className="w-form-done">
                          <div>
                            Thank you! Your submission has been received!
                          </div>
                        </div>
                        <div className="w-form-fail">
                          <div>
                            Oops! Something went wrong while submitting the
                            form.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="left_mobile_nav_trigger">
                      <div className="text-block-134 fa_icon"></div>
                      <img
                        alt=""
                        className="image-4 hidden"
                        loading="lazy"
                        prop-attr-names="src"
                        prop-attr-value-src="userpic"
                        src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                      />
                      <div className="text-block fa_icon arrow no-mr hidden">
                        
                      </div>
                    </div>
                  </div>
                  <div className="div-block-355 left_menu_mob">
                    <div className="div-block-3">
                      <div className="div-block-2 mt-reduced">
                        <a className="ai-skills-btn w-inline-block" href="#">
                          <div className="text-block-130">AI Skills</div>
                        </a>
                      </div>
                      <div className="div-block-2">
                        <a className="link-block-18 w-inline-block" href="#">
                          <div className="text-block-130">Downloads</div>
                        </a>
                      </div>
                      <div className="div-block-2 hidden">
                        <div className="notifications_trigger">
                          <a
                            className="link-block-18 w-inline-block"
                            href="notifications.html"
                          >
                            <div className="text-block-130">Notifications</div>
                          </a>
                        </div>
                      </div>
                      <div className="div-block-2 nav-field hidden">
                        <div className="roles">
                          <img
                            alt=""
                            className="user-img nb"
                            loading="lazy"
                            src="images/setting_1setting.png"
                          />
                          <div className="text-block-130 sp">Roles</div>
                          <div className="text-block fa_icon arrow"></div>
                          <div className="div-block-164 profile">
                            <div className="div-block-165">
                              <div className="text-block-104">
                                Ashley Miller
                              </div>
                              <div className="text-block-104 em">
                                ashley@gmail.com
                              </div>
                            </div>
                            <a
                              className="link-block-11 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-106">Overview</div>
                            </a>
                            <a
                              className="link-block-11 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-106">Profile</div>
                            </a>
                            <a
                              className="link-block-11 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-106">Log Out</div>
                            </a>
                          </div>
                          <div className="roles_popup">
                            <div className="div-block-195">
                              <a className="link-2" href="#">
                                Admin
                              </a>
                            </div>
                            <div className="div-block-195">
                              <a className="link-2" href="#">
                                Instructor
                              </a>
                            </div>
                            <div className="div-block-195 last">
                              <a className="link-2" href="#">
                                Editor
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <Usermenu></Usermenu>
                    </div>
                  </div>
                </div>
                <div className="main">
                  <Sidebar></Sidebar>
                  <div className="mob_sidebar_overlay"></div>
                  <div className="main-content">
                    <div className="div-block-183">
                      <div className="div-block-205">
                        <div className="div-block-206"></div>
                        <div className="text-block-113">
                          AUTHORING | COURSES
                        </div>
                      </div>
                      <div className="div-block-308">
                        <a
                          className="link-block-22 w-inline-block"
                          href="#"
                          prop-events-names="onClick"
                          prop-events-value-onclick="handleAddNewCourseClick"
                        >
                          <div className="div-block-207 first active follow-user">
                            <div className="text-block-111">Add New Course</div>
                          </div>
                        </a>
                      </div>
                    </div>
                    <Coursetable></Coursetable>
                  </div>
                  <Footer></Footer>
                </div>
              </div>
              <Copilot></Copilot>
            </div>
            <div className="w-layout-hflex floating-copilot-launcher hidden">
              <img
                alt=""
                loading="lazy"
                src="images/63fceefab0d14ad731da535e_ibl-logo-animated-2.gif"
              />
            </div>
          </div>
        </span>
      </span>
    );
  }
}

export default CoursesView;

/* eslint-enable */
